import { getGroup, updateGroup } from 'api/group';
import { toast } from 'react-toastify';

const RESET_GROUP = 'RESET_GROUP';
const SET_GROUP = 'SET_GROUP';
const UPDATE_GROUP = 'UPDATE_GROUP';


export function updateGroupData(id, groupData) {
    return async function(dispatch) {
        try {
            await updateGroup(id, groupData);

            dispatch({
                type: UPDATE_GROUP,
                group: groupData,
            });

            toast.success('Group updated', { autoClose: 1500 });
        }
        catch (err) {
            if (err.response && err.response.status === 422) {
                toast.error('Error! Failed to update group, Access Key already exists.', { autoClose: 2500 });
            }
            else {
                toast.error('Error! Failed to update group.', { autoClose: 2500 });
            }
        }
    };
}

export function resetGroup() {
    return {
        type: RESET_GROUP,
    };
}

export function loadGroup(id) {
    return async function(dispatch) {
        try {
            const group = await getGroup(id);

            dispatch({
                type: SET_GROUP,
                group: group.data,
            });
        }
        catch (err) {
            toast.error('Error! Failed to load group.');
        }
    };
}


const initialState = {
    group: {}
};

export default function group(state = initialState, action) {
    switch (action.type) {
        case RESET_GROUP:
            return {
                group: {},
            };
        case UPDATE_GROUP:
            return {
                group: {
                    ...state.group,
                    ...action.group,
                }
            };
        case SET_GROUP:
            return {
                group: action.group,
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/modules/group.js